import { Component, OnInit, ViewEncapsulation, ViewChild, Input, ElementRef} from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { FormGroup, NgForm, FormBuilder, Validators} from '@angular/forms';
import { WebService } from 'src/app/shared/services/web.service';
import { SecureLocalStorage } from '../../shared/services/secure-local-storage';
import { MenuItems } from '../../core/menu/menu-items/menu-items';
declare var $: any, bootbox: any;
import { filter } from 'rxjs/operators'
import { ReCaptcha2Component } from 'ngx-captcha';
import { EnvironmentUrlService } from '../../shared/services/environment-url.service';
@Component({
   selector: 'app-rm-login',
   templateUrl: './rm-login-component.html',
   styleUrls: ['./rm-login-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class RMLoginComponent {
  email: string;
  password: string;
  button: boolean = false;
  Genratebutton: boolean = true;
  Apiurl = '';
  searchLoginObj = new LoginObject();
	 enableLoginbutton: boolean = false;								 
  @ViewChild('loginForm') loginForm: NgForm;
  validation: boolean = false;
  otpvalidation: boolean = false;
  protected aFormGroup: FormGroup;
  @ViewChild('verifyForm') verifyForm: NgForm;
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @ViewChild('langInput') langInput: ElementRef;
  sessionId: any = null;
  tokenId: any;
  appCode: any;
  resultSet: any;
  LoginId: any;
  hideCaptcha: boolean = false;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';
  public siteKey: any;
  constructor(private route: ActivatedRoute,
    private router: Router, private webService: WebService, private secureLS: SecureLocalStorage, public menuItems: MenuItems, private formBuilder: FormBuilder, public _service: EnvironmentUrlService)
  {
    localStorage.clear();
    this.secureLS.removeStorage();
  }

  ngOnInit() {
    this.siteKey = this._service.siteKey;
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
    this.noBack();
    this.route.queryParams
      .pipe(filter(params => params.SessionId))
      .subscribe(params => {
        this.secureLS.removeStorage();
        this.sessionId = params.SessionId;
        this.tokenId = params.TokenId;
        this.appCode = 'APP0413';  //paramAppCode;
      });
    if (this.sessionId != null) {


      debugger

      //uat link
      //this.webService.getData('https://eicuat.rathi.com/Intra_uat/api/Intralogin/AuthenticateUser?SessionId=' + this.sessionId + '&' + 'TokenId=' + this.tokenId).subscribe((res: any) => {

      //Live link
    this.webService.getData('https://intra.rathi.com/api/Intralogin/AuthenticateUser?SessionId=' + this.sessionId + '&' + 'TokenId=' + this.tokenId).subscribe((res: any) => {



        this.secureLS.setStorage("rmloginbyIntra", true);
        this.resultSet = res.ResultData;
        console.log("this.resultSet.LoginId",this.resultSet.LoginId);
        this.LoginId = this.resultSet.LoginId;
        this.secureLS.setStorage("tokenId", this.tokenId);
        if (this.resultSet.LoginId != null) {
          this.hideCaptcha = true;
          this.enableLoginbutton = true;
          this.login_rm();
        } else {
          this.secureLS.removeStorage();
        }
      }, error => {

      })
    }
	    debugger;
    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });		 
  }
  noBack() {
    window.history.forward()
  }

  login_rm() {
    if (this.LoginId != null && this.LoginId != undefined) {
      console.log("LoginId", this.LoginId);

      let loginData = {
        "Loginname": this.LoginId,
        "EkycClientcode": null, "Password": null
      };
      this.Apiurl = "api/Authenticate/login";
      this.webService.postData(this.Apiurl, loginData).subscribe((data: any) => {
      console.log('data =', data);
        const time_to_login = Date.now();
        this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
        debugger
        if (data.statusCode == 200) {
          //bootbox.alert({
          //  message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>You Have Successfully Login As A RM</h6></div>",
          //  size: 'large'
          //});
          this.secureLS.setStorage('TokenId', data.token);
          this.secureLS.setStorage('RMTk', data);
          this.router.navigate(['dashboard/RmDashboard']);
        }
        else if (data.statusCode == "204") {
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
            size: 'large'
          });
        }

    }, error => {
      console.log('Error ', error);
      bootbox.alert({
        message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-3'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
        size: 'large'
      });
    })
    }
  }


  login() {

    if (!this.loginForm.valid) {
      this.validation = true;
    }
    else {
      console.log(this.searchLoginObj.Loginname, this.searchLoginObj.Password)
      this.Apiurl = "api/Authenticate/login";
        let loginData = {
          "Loginname": this.webService.encryptData(this.searchLoginObj.Loginname),
        "EkycClientcode": this.webService.encryptData(this.searchLoginObj.EkycClientcode),
        "Password": this.webService.encryptData(this.searchLoginObj.Password)
      };
      this.webService.postData(this.Apiurl, loginData).subscribe((data: any) => {
        console.log('data =', data);
        if (data.status == "1") {
          const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
          this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
          if (data.statusCode == 200) {
            bootbox.alert({
              message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>You Have Successfully Login As A RM</h6></div>",
              size: 'large'
            });
        
            this.secureLS.setStorage('RMTk', data);
            this.router.navigate(['dashboard/RmDashboard']);

            //Added by laxmi for IBS!
            debugger;
            localStorage.setItem('RMLoginAs', data.menu_role);
            if (data.menu_role == 'IBS') {
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
            }
            if (data.menu_role == 'Accountant') {
              this.router.navigate(['Reports/marginReport']);
              return 0;
            }
            

            this.secureLS.setStorage('TokenId', data.token);
            this.secureLS.setStorage('RMTk', data);
            this.router.navigate(['dashboard/RmDashboard']);
          }
          else if (data.statusCode == "204") {
            bootbox.alert({
              message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
              size: 'large'
            });
          }
        }
       
      }, error => {
        console.log('Error ', error);
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-3'></i><br>Invalid user-id or password information entered, Please correct and re-enter.</h6></div>",
            size: 'large'
          });
      })
    }
  }
  
  
	checkClientIdentitySubmitted() {
     
    
    var EkyclientCode = this.webService.encryptData(this.searchLoginObj.EkycClientcode);
    let url = "api/Authenticate/CheckClientIdentitySubmitted/" + EkyclientCode;
    this.webService.getData(url).subscribe((res: any) => {
       
      if (res != null) {
        const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
        this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
        if (res.statusCode == 404) {
          this.router.navigate(['client-basic-details/pan-search']);
        }
        if (res.statusCode == 200) {
          this.router.navigate(['client-basic-details/Client-DashBord']);
        }       
      }
     
    }, error => {

    });
  }
 handleSuccess(data) {
    console.log(data);
    this.enableLoginbutton = true;
  }					   
}
export class LoginObject {

  Loginname: string;
  Password: string;
  LoginOtp: number;
  EkycClientcode: number;
}


